import { __read, __values } from "tslib";
import { useAfterShellPlusLoaded, useShellShim, } from '@office-start/shell-shim-service';
import { useRegisterTeachingUiTargetElement, } from '@office-start/teaching-ui-service';
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState, } from 'react';
export function useShellElements(disabled) {
    if (disabled === void 0) { disabled = false; }
    var shellShim = useShellShim().shellShim;
    var _a = __read(useState(false), 2), shellPlusLoaded = _a[0], setShellPlusLoaded = _a[1];
    useAfterShellPlusLoaded(function () {
        setShellPlusLoaded(true);
    });
    var registerShellSettingsElement = useRegisterTeachingUiTargetElement('Shell_Settings');
    var idToTuiElementRegistrationFunc = useMemo(function () {
        return new Map([
            ['O365_MainLink_Settings_container', registerShellSettingsElement],
            ['settingsControl_container', registerShellSettingsElement],
        ]);
    }, [registerShellSettingsElement]);
    var knownShellElementIds = useMemo(function () {
        return new Set(idToTuiElementRegistrationFunc.keys());
    }, [idToTuiElementRegistrationFunc]);
    var mutationObserverSetup = useRef(undefined);
    var reloadShellElements = useCallback(function () {
        var _a, _b, _c;
        if (shellShim !== undefined && shellPlusLoaded && !disabled) {
            // Set initial values
            var settingsElement = (_b = (_a = document.getElementById('O365_MainLink_Settings_container')) !== null && _a !== void 0 ? _a : document.getElementById('settingsControl_container')) !== null && _b !== void 0 ? _b : document.getElementById('O365_MainLink_Affordance');
            registerShellSettingsElement(settingsElement);
            var elementToObserve = (_c = document.querySelector('#HeaderButtonRegion')) !== null && _c !== void 0 ? _c : document.getElementById('Region_6');
            if (!elementToObserve || mutationObserverSetup.current) {
                return;
            }
            var observerOptions = {
                subtree: false,
                childList: true,
            };
            var observer = new MutationObserver(function (mutations) {
                var e_1, _a;
                try {
                    for (var mutations_1 = __values(mutations), mutations_1_1 = mutations_1.next(); !mutations_1_1.done; mutations_1_1 = mutations_1.next()) {
                        var mutation = mutations_1_1.value;
                        if (mutation.type === 'childList') {
                            mutation.removedNodes.forEach(function (node) {
                                if (node.nodeType === Node.ELEMENT_NODE &&
                                    knownShellElementIds.has(node['id'])) {
                                    var registerTuiTarget = idToTuiElementRegistrationFunc.get(node['id']);
                                    if (registerTuiTarget) {
                                        // Attempt to replace the target with the overflow menu
                                        // when node is removed
                                        var affordance = document.getElementById('O365_MainLink_Affordance');
                                        registerTuiTarget(affordance);
                                    }
                                }
                            });
                            mutation.addedNodes.forEach(function (node) {
                                if (node.nodeType === Node.ELEMENT_NODE &&
                                    knownShellElementIds.has(node['id'])) {
                                    var registerTuiTarget = idToTuiElementRegistrationFunc.get(node['id']);
                                    registerTuiTarget === null || registerTuiTarget === void 0 ? void 0 : registerTuiTarget(node);
                                }
                            });
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (mutations_1_1 && !mutations_1_1.done && (_a = mutations_1.return)) _a.call(mutations_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
            observer.observe(elementToObserve, observerOptions);
            mutationObserverSetup.current = observer;
        }
    }, [
        shellShim,
        shellPlusLoaded,
        disabled,
        idToTuiElementRegistrationFunc,
        knownShellElementIds,
        registerShellSettingsElement,
    ]);
    useLayoutEffect(function () {
        reloadShellElements();
    }, [reloadShellElements]);
    useEffect(function () {
        var _a;
        if (disabled) {
            (_a = mutationObserverSetup.current) === null || _a === void 0 ? void 0 : _a.disconnect();
            mutationObserverSetup.current = undefined;
        }
    }, [disabled]);
    return reloadShellElements;
}
//# sourceMappingURL=useShellElements.js.map